

// Note: Helper functions: Bottom of this file


// --------------
function propExists(obj, prop = '') {
    return isDefined(obj[prop])
}
function propExistsElseError(obj, prop = '', methodName) {
    // console.log('PROP NAME', obj, prop)
    if (!propExists(obj, prop)) {
        throw new Error(`Schema Error: Property access: Method: ${methodName} : Property: ${prop} does not exist.`);
    }
}
// ----------------


function init(schemaInstance, schema) {
    schemaInstance.schema = schema;
    schemaInstance.type = 'SchemaWrapper'
}


var SchemaApi = {
    getProps() {
        return Object.keys(this.schema);
    },

    getProp(prop) {
        try {
            propExistsElseError(this.schema, prop, 'getProp');
            return this.schema[prop];
        } catch (err) {
            console.error(err);
        }
    },

    // Return array of validation rules
    getValidationRules() {
        return Object.keys(this.schema).map(schemaProp => this.getValidationRule(schemaProp)).filter(rule => isDefined(rule));
    },

    // Return object: Keys: Schema props that HAVE a validation rule; values: the validation rule (which is an obj)
    getValidationRulesObj() {
        var validationRules = {};
        this.getProps().forEach(prop => {
            if (this.hasValidationRule(prop)) {
                validationRules[prop] = this.getValidationRule(prop);
            }
        });
        return validationRules;
    },

    // getPropOfProp('label','fName') >> 'Get the label property of the fName schema property
    getPropOfProp(prop, schemaProp) {
        try {
            this.getProp(schemaProp);
            // propExistsElseError(this.schema, schemaProp, 'getPropOfProp-SchemaPropAccess');
            propExistsElseError(this.schema[schemaProp], prop, 'getPropOfProp-propOfTheSchemaProp');
            return this.schema[schemaProp][prop];

        } catch (err) {
            console.error(err);
        }
    },

    // Return true if prop exists on the schema obj; otherwise return false
    propExists(prop) {
        return propExists(this.schema, prop);
    },

    // Validation rule can be specified on a shema prop using one of these two prop names: v, validation
    hasValidationRule(prop) {
        try {
            propExistsElseError(this.schema, prop, 'hasValidationRule');
            return propExists(this.getProp(prop), 'v') || propExists(this.getProp(prop), 'validation');
        } catch (err) {
            console.error(err)
        }
        // try {
        //     if (this.propExists(prop)) {
        //         // return propExists(this.schema[prop], 'v') || propExists(this.schema[prop], 'validation');
        //         return propExists(this.getProp(prop), 'v') || propExists(this.getProp(prop), 'validation');
        //     }
        //     throw new Error(`Schema Error: hasValidationRule() error: Schema does not have property: ${prop}`)
        // } catch (err) {
        //     console.error(err)
        // }
    },


    // Return validation rule for prop. Throws error if prop doesn't exist. If it does and has no validation rule, returns undefined.
    getValidationRule(prop) {
        try {
            propExistsElseError(this.schema, prop, 'getValidationRule');
            var valRule;
            if (propExists(this.getProp(prop), 'validation')) {
                valRule = this.getProp(prop)['validation']
            }
            if (propExists(this.getProp(prop), 'v')) {
                valRule = this.getProp(prop)['v']
            }
            return valRule;
        } catch (err) {
            console.error(err);
        }
    },

    // For given schema prop, get its validation rule property, e.g. schema entry:
    // dogName: {
    //     label: 'Dog Name',
    //     context: { frontend: true },
    //     validation: {
    //         required: 'Dog name required.',
    //         max: [5, 'Dog name can be at most 5 characters.']
    //     },
    //     default: 'Riley'
    // }
    //  ... and we want the 'required' validation property, THIS method will return its value. 
    //  >> e.g. .getValidationRuleProp('dogName','required').
    //  Throws error if the val rule prop does not exist.
    getValidationRuleProp(prop, ruleProp) {
        try {
            var valRule = this.getValidationRule(prop);
            propExistsElseError(valRule, ruleProp, 'getValidationRuleProp');
            return valRule[ruleProp]
        } catch (err) {
            console.error(err)
        }
    },

    // For given schema prop, check if its validation rule exists. Return true if so, false if not.
    // NOTE: For better context of what this method is accessing, see notes above for getValidationRuleProp().
    validationRulePropExists(prop, ruleProp) {
        try {
            var valRule = this.getValidationRule(prop);
            return propExists(valRule, ruleProp, 'getValidationRuleProp');
        } catch (err) {
            console.error(err)
        }
    },


    // *** No TYPE checking is done (for now)... need to know the type of data the validation rule needs, e.g.
    //  'required' has a single 'string' value; 'max' has an array value with array[0] storing a number (max length) and array[1] storing 
    //  validation-failed text, etc. (So, DON'T set the 'max' rule, for example, to a single string - the validator will groan!)
    // Call example: mySchema.setValidationRuleText('status', 'required', 'Please fill in status.')
    setValidationRuleValue(prop, ruleProp, ruleVal) {
        var valRule = this.getValidationRule(prop);
        try {
            propExistsElseError(valRule, ruleProp, 'setValidationRuleText');
            valRule[ruleProp] = ruleVal;
        } catch (err) {
            console.error(err)
        }
    },


    // Generate and return a list of all contexts found in the schema.
    getAllContexts() {
        var allContexts = [];
        this.getProps().forEach(prop => {
            allContexts = [...allContexts, ...this.getContext(prop, true)]
        })
        // Dedupe allContexts
        return allContexts.reduce((a, c) => {
            if (a.includes(c)) {
                return a
            }
            return a.concat(c);
        }, []);
    },


    // If contextVal is undefined, will return true/false depending on whether or not the schema prop has a context set, i.e. whether
    // or not the schema prop has a property named: context
    // WITH a contextVal, will return true/false if the context value contains the contextVal.
    // Note: See comment on getContext() method for note about arrayOnUndefined
    hasContext(prop, contextVal, arrayOnUndefined) {
        // console.log('hasContext', prop, isDefined(contextVal))
        try {
            propExistsElseError(this.schema, prop, 'hasContext');
            if (isUndefined(contextVal)) {
                // console.log('UNDEFINED!!!!!!!!!!')
                return propExists(this.getProp(prop), 'context')
            }
            return this.getContext(prop, arrayOnUndefined).includes(contextVal);

        } catch (err) {
            console.error(err);
        }
    },

    // Return array of context values, if any, for prop.
    // Context value can be: string, array of strings, or object (where each key is the context value and the value is a bookean).
    // If not context property on the schema prop, returns empty array if arrayOnUndefined param is present/true in the caller; undefined if that param is falsey.
    getContext(prop, arrayOnUndefined) {
        try {
            propExistsElseError(this.schema, prop, 'getContext');
            var contextVal = this.getProp(prop).context;
            if (typeof contextVal === 'string') {
                return [contextVal]
            }
            if (isArray(contextVal)) {
                return contextVal;
            }
            if (isObjectLiteral(contextVal)) {
                return Object.keys(contextVal)
            }
            return arrayOnUndefined ? [] : undefined;
        } catch (err) {
            console.error(err);
        }
    },

    // temp - testing concept
    // runner(prop, methodName, fn) {
    //     console.log(prop, methodName, fn)
    //     try {
    //         propExistsElseError(this.schema, prop, methodName);
    //         return fn(prop);
    //         // return this.getProp(prop).default;
    //     } catch (err) {
    //         console.error(err);
    //     }
    // },


    // Create schemaProp-to-valueOfProp map, for each schema prop, map it to its target prop, e.g.
    // schema prop mapping to its label, e.g. {fName:'First Name'}
    // If getterMethodName specified, see if it exists here; if so, call it. Otherwise, use simple getter using the targetProp.
    createPropMap(targetProp, getterMethodName) {
        var propMap = {};
        var getterMethod = typeof this[getterMethodName] === 'function' ? this[getterMethodName] : false;
        this.getProps().forEach(prop => {
            // propMap[prop] = this.getProp(prop)[targetProp] !== undefined ? this.getProp(prop)[targetProp] : undefined;
            propMap[prop] = getterMethod
                ? getterMethod.call(this, prop)
                : (this.getProp(prop)[targetProp] !== undefined ? this.getProp(prop)[targetProp] : undefined);
        })
        return propMap;
    },


    getDefault(prop) {

        // runner
        // var gd = () => this.getProp(prop).default;
        // return this.runner(prop, 'getDefault', gd);
        // -------

        try {
            propExistsElseError(this.schema, prop, 'getDefault');
            return this.getProp(prop).default;
        } catch (err) {
            console.error(err);
        }
    },

    getLabel(prop) {
        // return this.getPropOfProp('label', prop); // works
        try {
            propExistsElseError(this.schema, prop, 'getLabel');
            return this.getProp(prop).label !== undefined ? this.getProp(prop).label : prop;
        } catch (err) {
            console.error(err);
        }
    },

    setLabel(prop, labelVal) {
        try {
            propExistsElseError(this.schema, prop, 'setLabel');
            this.getProp(prop).label = labelVal;
        } catch (err) {
            console.error(err);
        }
    },

    // If property prop has a 'truncate' property, and if its value is a number, return that number. Otherwise, return undefined
    getTruncate(prop) {
        try {
            propExistsElseError(this.schema, prop, 'getTruncate');
            return (this.getProp(prop).truncate !== undefined && typeof this.getProp(prop).truncate === 'number') ? this.getProp(prop).truncate : undefined;
        } catch (err) {
            console.error(err);
        }
    },

    // Generate and return an object of all props in the schema that have a truncate property set.
    // Returned obj: Keys: prop  Values: value of the truncate value of the property
    getAllTruncates() {
        var truncates = {};
        this.getProps().forEach(prop => {
            truncates[prop] = this.getTruncate(prop);
        })
        return truncates
    }

}


var Schema = function (schema) {
    if (!isObjectLiteral(schema)) {
        throw new Error('Error Creating Schema Wrapper: Missing or invalid argument: Argument to constructor must be an object literal.');
    }
    var schemaApi = Object.create(SchemaApi);
    init(schemaApi, schema);
    return schemaApi;
}

export { Schema };



function isArray(val) {
    if (typeof val === 'object' && Array.isArray(val)) {
        return true;
    }
    return false;
}

function isObjectLiteral(val) {
    var type = typeof val;
    return val != null && type === 'object' && !isArray(val);
}

function isDefined(val) {
    return !isUndefined(val);
}

function isUndefined(val) {
    return val === undefined;
}

